<template>
  <div id="pedidos-vencendo" class="w3-container w3-margin-top" style="padding: 0;">
    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom" >
      <input 
        class="w3-input w3-border w3-padding margin-bottom-filtro" 
        type="text" 
        placeholder="Pesquise por CPF/CNPJ ou nome razão social"
        v-model="filtro_pedidos"
        v-on:keyup="filtrarPedidos()">
        
    </div>

    <div 
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left" 
      v-if="(Object.keys(pedidos_filtrados).length === 0) && 
      !processando"
      v-cloak>
      <div class="w3-container w3-white">
        <p>Não há pedidos a serem exibidos.</p>
      </div>
    </div>
    

    <div 
      class="wrapper-componente" 
      v-if="(Object.keys(pedidos_filtrados).length > 0) && 
      !processando">
      
      <div 
        class="w3-container card-informacoes"
        v-for="(pedido, pedido_index) in novosPedidosFiltrados" 
        :key="pedido_index">
        
        <div class="w3-col s12 w3-text-theme">
          <strong>{{ pedido.cliente_id }} - {{ pedido.razao_social_cliente }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>CPF/CNPJ: </label>
          <strong>{{ pedido.cpf_cnjp_cliente }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Data de Cadastro: </label>
          <strong>{{ pedido.data_cadastro }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Orçamento: </label>
          <strong>{{ pedido.orcamento_id }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Valor do pedido</label>
          <strong>R$ {{ pedido.valor_pedido }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Vendedor: </label>
          <strong>{{ pedido.vendedor_origem }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Empresa: </label>
          <strong>{{ pedido.empresa_orcamento }}</strong>
        </div>
      </div>
    </div>

    <paginacao 
      @pagina="mudarPagina" 
      :pagina-atual="paginaAtual" 
      :itens-por-pagina="itensPorPagina"
      :total-resultados="totalResultados" 
      :total-de-paginas="totalDePaginas"/>
        
  </div>
</template>

<script>
  import Paginacao from '@/components/Paginacao'
  import toastr from 'toastr'
  import ROrcamentoBuscarPedidosVencendo from '@/components/Rest/ROrcamento/ROrcamentoBuscarPedidosVencendo.js'
  
  export default {
    name: 'PedidosVencendo',

    components: {
      Paginacao
    },

    props: ['quantidade_dias'],
    
    data() {
      return {
        api: process.env.API,
        pedidos_vencendo: [],
        qtd_pedidos_vencendo: 0,
        processando: false,
        filtro_pedidos: '',
        pedidos_filtrados: [],

        /* PAGINAÇÃO */
        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0
      }
    },
    
    mounted() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },
    
    methods: {
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },

      filtrarPedidos() {
        this.pedidos_filtrados = [];
        this.mudarPagina(0);
      
        if(this.filtro_pedidos == '') {
          this.pedidos_filtrados = this.pedidos_vencendo;
          return;
        }
        
        for (let i = 0; i < this.pedidos_vencendo.length; i++) {
          if (this.pedidos_vencendo[i].razao_social_cliente.toUpperCase().indexOf(this.filtro_pedidos.toUpperCase()) > -1) {
            this.pedidos_filtrados.push(this.pedidos_vencendo[i]);
          }

          if (this.pedidos_vencendo[i].cpf_cnjp_cliente.replace(".", "").replace("-", "").indexOf(this.filtro_pedidos) > -1) {
            this.pedidos_filtrados.push(this.pedidos_vencendo[i]);
          }
        }
      },

      async buscarPedidosVencendo() {
        this.processando = true;

        try {
          let parametros = {
            intervalo_dias_pesquisa: this.quantidade_dias
          }

          let retorno = await ROrcamentoBuscarPedidosVencendo.buscarPedidosVencendo(
            this.axios, 
            parametros
          );

          console.log('retorno', retorno)

          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          this.pedidos_vencendo = []
          this.pedidos_filtrados = []
          
          if (retorno.dados) {
            this.pedidos_vencendo = JSON.parse(JSON.stringify(retorno.dados));
            this.pedidos_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            this.qtd_pedidos_vencendo = this.pedidos_vencendo.length;
          }          
          this.processando = false;
        } 
        catch (error) {
          this.processando = false;
        }
      },
    },

    created() {
      this.buscarPedidosVencendo();
    },

    computed: {
      novosPedidosFiltrados() {
        this.totalResultados = this.pedidos_filtrados.length;
        this.totalDePaginas =  Math.ceil(this.totalResultados / this.itensPorPagina);
        if(this.paginaAtual >= this.totalDePaginas) { 
          this.paginaAtual = this.totalDePaginas;
        }
        var index = this.paginaAtual * this.itensPorPagina;
        return this.pedidos_filtrados.slice(index, index + this.itensPorPagina);
      }
    }
  }
</script>

<style scoped>
  th, .nowrap {
    white-space: nowrap !important;
  }
  
  th, .nowrap {
    white-space: nowrap !important;
  }

  .card-informacoes {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .titulo {
    white-space: nowrap;
    text-align: right
  }
  
  td {
    white-space: nowrap;
  }
  
  .produtos-em-promocao {
    overflow: auto;
  }
  
  .wrapper-componente {
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/PedidosVencendo.vue